<template>
	<div class="all">
        
        <!-- 反馈成功弹框 -->
        <toast-modal :isToast="isToast" :ToastText="ToastText"></toast-modal>
        <div class="assessWrap">
			<img :src="imgUrl+server_icon" class="assess-icon">
			<div>
				<p class="assess-title">{{server_name}}</p>
				<div class="ping_jia_level">
					<span class="level" v-for="index in 5" :key="index" @click="rateStar(index)" :class="(cur>=index)?'on':'off'"></span>
				</div>
			</div>
		</div>
		
		<div class="form">
			<textarea class="textarea" placeholder="*请输入您的内容" v-model="addBody.feedback" :rows="8" @input="onFeabbackIput"/>
			<div class="limit">
				<span class="word-length">{{value_length}}</span>
				<span class="limit-amount">/200</span>
			</div>
	
			<!-- <div class="num">上传图片（{{ addBody.feedback_images.length }}/6）</div>
			<imageUpload v-model="addBody.feedback_images" :limit="6"/> -->
		</div>
	
		<div class="submitBtn" @click="onSubmitClick">发表评价</div>
	</div>
</template>

<script>
import imageUpload from '@/components/ImageUpload';
import CommonHeader from '@/components/CommonHeader';
import ToastModal from '@/components/ToastModal'
import {getOrderComment} from '@/api/order'
export default {
	data() {
		return {
			imgUrl:this.$store.state.imgUrl || sessionStorage.getItem("imgUrl"),
			addBody: {
				feedback: '',
				feedback_images: [],
			},
            order_uuid:this.$route.query.order_uuid,
            server_icon:this.$route.query.server_icon,
            server_name:this.$route.query.server_name,
            url:this.$route.query.url,
			value_length: 0,
			cur:-1,
            ToastText:"评价成功",     //驳回，催单，取消，反馈成功提示语
            isToast:false
		};
	},
	
	beforeCreate(){
		sessionStorage.setItem("roleType","customer")
	},
    
    mounted(){
       document.title = "评价"
    },
 
	methods: {
        // 发表评论
		onSubmitClick() {
            if(this.cur<0){
               window.toast('请评价该订单', 'txt');
               return 
            }
			this.network().addFeedback()
		},
        
		network() {
			return {
				addFeedback: async () => {
					if (this.addBody.feedback ==="") {
						window.toast('说点什么吧', 'txt');
						return
					}
					if (this.addBody.feedback.length>200) {
						window.toast('输入文字不得超过200个字符', 'txt');
						return
					}
                    let obj={star:this.cur,order_uuid:this.order_uuid,comment:this.addBody.feedback,comment_img:this.addBody.feedback_images}
					const { status, data } = await getOrderComment(obj)
					if (status !== 200) return
					this.isToast = true;
                    var timer;
                    clearTimeout(timer);
                    timer = setTimeout(()=>{
                        location.href = this.url;
                    },1500)
                    
				}
			}
		},

		onFeabbackIput(val) {
			this.value_length = this.addBody.feedback.length;
		},
		
		onCloseModalClick () {
			this.$router.go(-1);
		},
		
		//星级评价
		rateStar(index){
			this.cur = index;
		}
	},
	
	components: {
		imageUpload,
		CommonHeader,
        ToastModal
	},
};
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variable.less';
@import '~@/assets/styles/handleMethods.less';
.all{
	background: #F5F5F5;
	.modal {
	  .w(239);
	  .h(209);
	  background: #fff;
	  border-radius:4px;
	  display: flex;
	  flex-direction: column;
	  justify-content: center;
	  align-items: center;
	  .succ-icon {
		.w(100);
		.h(111.5);
	  }
	  .succ-text {
		.h(25);
		.l-h(25);
		.f-s(18);
		.m-t(16);
		font-family:PingFangSC-Regular;
		font-weight:400;
		color:rgba(0,0,0,1);
	  }
	}
	
	.assessWrap{
		.w(375);
		.h(100);
		.p-l(22);
		.m-b(10);
		display: flex;
		align-items: center;
		background: #fff;
		.assess-icon{
			.w(58);
			.h(60);
			.m-r(17);
		}
		.assess-title{
			.f-s(18);
			font-family:PingFangSC-Medium;
			font-weight:500;
			color:rgba(20,20,20,1);
		}
		
		.ping_jia_level{
			.p-t(4);
			display: flex;
			align-items: center;
			.m-t(10);
			.level{
				display: inline-block;
				.w(19);
				.h(19);
				.m-r(8.5);
				
			}
			.on{
				background: url(../../assets/images/home/ic_home_star_light.png) no-repeat center center;
				background-size:cover
			}
			.off{
				background: url(../../assets/images/order-manage/ic_home_star_formal.png) no-repeat center center;
				background-size:cover
			}
		}

	}
	.form {
		position: relative;
		background: #fff;
		.textarea {
			.w(345);
			.m-l(15);
			.m-r(15);
			.m-t(12.5);
			.p-l(10);
			.p-t(10);
			.p-r(10);
			.p-b(10);
			.l-h(20);
			.f-s(14);
			border: none;
			resize: none;
			outline: none;
			border-bottom: 1px solid #E5E5E5;
			font-family:PingFangSC-Regular;
			font-weight:400;
			color:rgba(153,153,153,1);
			box-sizing: border-box;
		}
		.limit {
			.h(20);
			.l-h(24);
			.f-s(14);
			position: absolute;
			.t(164);
			.r(20);
			font-family:PingFangSC-Regular;
			font-weight:400;
			color:rgba(245,166,35,1);
			.word-length{
				color: #4184F4;
				.f-s(14)
			}
			.limit-amount {
				color:#4A4A4A;
				.f-s(14)
			}
		}
		.num {
			.h(16.5);
			.l-h(16.5);
			.f-s(12);
			.m-l(15);
			.m-t(10);
			.m-b(12.5);
			font-family:PingFangSC-Regular;
			font-weight:400;
			color:rgba(155,155,155,1);
		}
	}
	.submitBtn {
		.w(337.5);
		.h(46);
		.l-h(46);
		.f-s(18);
		.m-l(15);
		.m-t(20);
		border-radius:2px;
		text-align: center;
		background:rgba(65,132,244,1);
		font-family:PingFangSC-Regular;
		font-weight:400;
		color:rgba(255,255,255,1);
	}
}
</style>
